import { baseUrl } from "../../utils/env";
import axios from "axios";
import {
  ROMANIA_DESCRIPTION_LIST_FAIL,
  ROMANIA_DESCRIPTION_LIST_REQUEST,
  ROMANIA_DESCRIPTION_LIST_SUCCESS,
  ROMANIA_DESCRIPTION_UPDATE_FAIL,
  ROMANIA_DESCRIPTION_UPDATE_REQUEST,
  ROMANIA_DESCRIPTION_UPDATE_SUCCESS,
} from "../constants/aboutRomaniaConstant";
import { toast } from "react-toastify";

export const listRomaniaDescription = () => async (dispatch) => {
  try {
    dispatch({ type: ROMANIA_DESCRIPTION_LIST_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.get(`${baseUrl}/about_romania`, config);

    dispatch({
      type: ROMANIA_DESCRIPTION_LIST_SUCCESS,
      payload: data[0],
    });
  } catch (err) {
    dispatch({
      type: ROMANIA_DESCRIPTION_LIST_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
export const updateRomaniaDescription =
  (description, descriptionId) => async (dispatch, getState) => {
    try {
      dispatch({ type: ROMANIA_DESCRIPTION_UPDATE_REQUEST });
      const {
        adminLogin: { adminInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${adminInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `${baseUrl}/about_romania/${descriptionId}`,
        {
          description,
        },
        config
      );

      toast.info("Description Updated Successfully", {
        autoClose: 1000,
      });
      dispatch({
        type: ROMANIA_DESCRIPTION_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (err) {
      toast.error("Fail To Update Description", {
        autoClose: 1000,
      });
      dispatch({
        type: ROMANIA_DESCRIPTION_UPDATE_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
